/** Split from viewers.tsx so that file only exports components
 * (react-refresh/only-export-components — same split as
 * WorkflowOverview/configure/publishFindings.ts). */
import type { DisplaySource } from '@/types/source'

/** PDF detection drives both the iframe embed and the forced blob MIME type. */
export function isPdfSource(source: DisplaySource): boolean {
  return Boolean(
    source.storage_url?.toLowerCase().includes('.pdf') ||
      source.source_filename?.toLowerCase().endsWith('.pdf')
  )
}
